(() => {
  const feedback = document.querySelector('[data-chat-feedback]');
  if (!feedback || feedback.dataset.bound) return;
  feedback.dataset.bound = 'true';
  let pending;
  let removeCloseListener = () => {};
  const overlays = '#cart-drawer[open], dose-finder-modal[open], navigation-drawer[open], quick-buy-drawer[open]';

  function status(kind, trigger) {
    feedback.replaceChildren();
    if (!kind) return;
    const banner = document.createElement('div');
    banner.className = `banner banner--${kind === 'error' ? 'error' : 'warning'}`;
    const text = document.createElement('span');
    text.textContent = feedback.dataset[kind];
    banner.append(text);
    if (kind === 'error') {
      const link = document.createElement('a');
      link.href = trigger.href;
      link.textContent = feedback.dataset.contact;
      banner.append(link);
    }
    feedback.append(banner);
  }

  function finish(attempt, error = false) {
    if (pending !== attempt) return;
    pending = null;
    attempt.controller.abort();
    clearTimeout(attempt.timeout);
    clearInterval(attempt.check);
    attempt.trigger.removeAttribute('aria-busy');
    if (!attempt.opened) attempt.removeCloseListener?.();
    status(error ? 'error' : null, attempt.trigger);
  }

  async function dismissDrawer(drawer, signal) {
    if (!drawer?.open) return;
    // The theme's after-hide event precedes focus-trap's asynchronous return
    // focus. Wait for both supported completions, never an animation delay.
    let dismissed;
    const hidden = new Promise(resolve => {
      dismissed = resolve;
      drawer.addEventListener('dialog:after-hide', resolve, { once: true, signal });
      signal.addEventListener('abort', resolve, { once: true });
    });
    const returned = new Promise(resolve => {
      if (!drawer.focusTrap.active) { resolve(); return; }
      signal.addEventListener('abort', resolve, { once: true });
      drawer.focusTrap.deactivate({
        onDeactivate: () => {},
        checkCanReturnFocus: () => hidden,
        onPostDeactivate: resolve
      });
    });
    try {
      drawer.hide();
      await Promise.all([hidden, returned]);
    } finally {
      dismissed();
    }
  }

  function ready(signal) {
    if (window.GorgiasChat) return Promise.resolve().then(() => window.GorgiasChat.init());
    return new Promise(resolve => {
      window.addEventListener('gorgias-widget-loaded', resolve, { once: true, signal });
      signal.addEventListener('abort', resolve, { once: true });
    });
  }

  document.addEventListener('click', async event => {
    const trigger = event.target.closest?.('[data-gorgias-chat-trigger]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || trigger.hasAttribute('download') || (trigger.target && trigger.target !== '_self')) return;
    event.preventDefault();
    if (pending) return;
    const drawer = trigger.closest('#header-sidebar-menu');
    const section = trigger.closest('.shopify-section');
    const attempt = { trigger, controller: new AbortController() };
    pending = attempt;
    const { signal } = attempt.controller;
    const valid = () => pending === attempt && trigger.isConnected && (!section || section.isConnected);
    trigger.setAttribute('aria-busy', 'true');
    status('loading', trigger);
    attempt.timeout = setTimeout(() => finish(attempt, true), 7500);
    // Bounded, attempt-only cancellation check; never polls for widget readiness.
    attempt.check = setInterval(() => {
      if (!valid()) finish(attempt);
    }, 150);
    try {
      await dismissDrawer(drawer, signal);
      if (!valid()) return;
      await ready(signal);
      if (!valid()) return;
      if (document.querySelector(overlays)) { finish(attempt); return; }
      const api = window.GorgiasChat;
      const returnTarget = drawer
        ? document.querySelector('button[aria-controls="header-sidebar-menu"]')
        : trigger;
      removeCloseListener();
      if (api?.on && api?.off) {
        const closed = () => {
          removeCloseListener();
          if (!document.querySelector(overlays) && returnTarget?.isConnected && returnTarget.getClientRects().length) returnTarget.focus({ preventScroll: true });
        };
        api.on('widget:closed', closed);
        removeCloseListener = () => { api.off('widget:closed', closed); removeCloseListener = () => {}; };
        attempt.removeCloseListener = removeCloseListener;
      }
      await api.open();
      attempt.opened = true;
      finish(attempt);
    } catch (_) {
      if (pending !== attempt) return;
      removeCloseListener();
      if (valid()) finish(attempt, true);
      else finish(attempt);
    }
  });
  // Cancel when a different overlay opens, even if it closes before chat loads.
  document.addEventListener('toggle', event => {
    if (pending && event.target.matches?.(overlays)) finish(pending);
  }, true);
  document.addEventListener('shopify:section:unload', event => {
    if (pending && event.target.contains(pending.trigger)) finish(pending);
  });
  window.addEventListener('pagehide', () => {
    if (pending) finish(pending);
    removeCloseListener();
  });
})();
